import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import StatsRing from './StatsRing';

const { FiSparkles, FiList, FiZap, FiCheckCircle, FiTrash2, FiChevronLeft, FiChevronRight, FiTag } = FiIcons;

function Sidebar({
  filter, setFilter, counts, progress, onClearDone,
  categories, categoryFilter, setCategoryFilter,
  collapsed, onToggleCollapse
}) {
  const items = [
    { key: 'all', label: 'All tasks', icon: FiList, count: counts.all },
    { key: 'active', label: 'In progress', icon: FiZap, count: counts.active },
    { key: 'done', label: 'Completed', icon: FiCheckCircle, count: counts.done }
  ];

  return (
    <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-top">
        <div className="brand">
          <div className="brand-mark"><SafeIcon icon={FiSparkles} /></div>
          {!collapsed && <span>focus list</span>}
        </div>
        <button
          className="collapse-btn"
          onClick={onToggleCollapse}
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          <SafeIcon icon={collapsed ? FiChevronRight : FiChevronLeft} />
        </button>
      </div>

      {!collapsed ? (
        <div className="ring-block">
          <StatsRing progress={progress} />
          <p>Keep the momentum going — every small task counts.</p>
        </div>
      ) : (
        <div className="ring-block-mini">
          <StatsRing progress={progress} size={46} />
        </div>
      )}

      <nav className="filter-list" aria-label="Task filters">
        {items.map(({ key, label, icon, count }) => (
          <button
            key={key}
            className={`filter-item ${filter === key ? 'selected' : ''}`}
            onClick={() => setFilter(key)}
            title={label}
          >
            <SafeIcon icon={icon} />
            {!collapsed && <span>{label}</span>}
            {!collapsed && <em>{count}</em>}
          </button>
        ))}
      </nav>

      {!collapsed && categories.length > 0 && (
        <div className="category-block">
          <p className="category-heading"><SafeIcon icon={FiTag} /> Categories</p>
          <div className="category-list">
            <button
              className={`category-item ${categoryFilter === 'all' ? 'selected' : ''}`}
              onClick={() => setCategoryFilter('all')}
            >
              All
            </button>
            {categories.map((category) => (
              <button
                key={category}
                className={`category-item ${categoryFilter === category ? 'selected' : ''}`}
                onClick={() => setCategoryFilter(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      )}

      <button className="clear-btn" onClick={onClearDone} disabled={!counts.done} title="Clear completed">
        <SafeIcon icon={FiTrash2} />
        {!collapsed && <span>Clear completed</span>}
      </button>
    </aside>
  );
}

export default Sidebar;